import {useCallback} from "react"
import {useQuery, useQueryClient} from "@tanstack/react-query"
import {documentTypesService} from "services"
import {UNLIMITED_PAGE_SIZE} from "data/constants"

const queryCacheKey = "all-document-types"
const INITIAL_DATA = []

export const useAllDocumentTypes = () => {
    const queryClient = useQueryClient()

    const query = useQuery(
        [queryCacheKey],
        async () => {
            const {data} = await documentTypesService.getAll({
                range: {
                    page: 1,
                    pageSize: UNLIMITED_PAGE_SIZE
                },
                linkedEntities: true
            })
            return data
        },
        {
            refetchOnMount: true
        }
    )

    return {
        documentTypes: query.data ?? INITIAL_DATA,
        invalidateDocumentTypesCache: useCallback(() => {
            queryClient.invalidateQueries({queryKey: [queryCacheKey]})
        }, [queryClient])
    }
}
